import { CheckpointStatusType } from '@fi-shared/checklist/checklist-types';
import { IFiChecklistAnswerModel, IFiChecklistCheckpointModel, IFiChecklistModelBase } from '@fi-shared/checklist';
import { FicQRAction } from '../../../../app-cordova/app/fic-services/fic-scan-qr-code.service';
import { AppTextService } from '@fi-shared/app-text';

export class ChecklistAnswerQrCodeHelper {
    constructor(
        private checklist: IFiChecklistModelBase,
        private checkpoint: IFiChecklistCheckpointModel,
        private checkpointAnswer: IFiChecklistAnswerModel,
        private mobileAppMode: boolean,
        private checklistPresenceEnabled: boolean,
        private appTextService: AppTextService,
    ) {}

    needsQRValidation(hasValidQRCode: boolean): boolean {
        //const answer = this.checkpointAnswer.Answer;
        return (
            this.mobileAppMode &&
            this.checklistPresenceEnabled &&
            this.checklist.CheckPresenceEnabled &&
            this.checkpoint.CheckPresence &&
            !hasValidQRCode /* &&
            answer !== CheckpointStatusType.Ok &&
            answer !== CheckpointStatusType.NotOk*/
        );
    }

    validateQRCode(code: FicQRAction) {
        return new Promise<void>((resolve, reject) => {
            if (code.type !== FicQRAction.TYPE_CHECKPOINT) {
                reject({
                    text: this.appTextService.get('checklist_qr.invalid_qr_format_text'), // 'The scanned data did not match the expected format.',
                    title: this.appTextService.get('checklist_qr.invalid_qr_format_title'), // 'Invalid QR code'
                });
                return;
            }

            // const scannedUnitId = code.parsedData.unitId;
            const scannedChecklistId = code.parsedData.checklistId;
            const scannedSortIndex = code.parsedData.checkpoint;

            // const unitId = this.sessionService.getSession().User.BusinessUnitId;
            const checklistId = this.checklist.Id;
            const sortIndex = this.checkpoint.SortIndex;

            const errors = [];

            /*
            if (scannedUnitId !== unitId) {
                errors.push(this.appTextService.get('checklist_qr.incorrect_unit_id', {
                    '{scannedUnitId}': scannedUnitId,
                    '{unitId}': unitId
                })); // 'Incorrect unit ID {scannedUnitId} (expected {unitId}).'
            }
            */

            if (scannedChecklistId !== checklistId)
                errors.push(
                    this.appTextService.get('checklist_qr.incorrect_checklist_id', {
                        '{scannedChecklistId}': scannedChecklistId,
                        '{checklistId}': checklistId,
                    }),
                ); // 'Incorrect checklist ID {scannedChecklistId} (expected {checklistId}).'

            if (scannedSortIndex !== sortIndex)
                errors.push(
                    this.appTextService.get('checklist_qr.incorrect_checkpoint_id', {
                        '{scannedSortIndex}': scannedSortIndex,
                        '{sortIndex}': sortIndex,
                    }),
                ); // 'Incorrect checkpoint {scannedSortIndex} (expected {sortIndex}).'

            if (errors.length === 0) {
                resolve();
            } else {
                reject({
                    text: errors.join(' '),
                    title: this.appTextService.get('checklist_qr.incorrect_qr_code'), // 'Incorrect QR code'
                });
            }
        });
    }
}
